import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "p-4 mb-4 bg-white shadow-md md:flex rounded-3xl shadow-black/5 ring-1 ring-black/5" }
const _hoisted_2 = ["href", "alt", "title"]
const _hoisted_3 = ["src", "alt", "title"]
const _hoisted_4 = { class: "justify-between ml-4 md:flex-1 md:flex md:flex-col" }
const _hoisted_5 = { class: "items-center flex-none mb-2" }
const _hoisted_6 = ["href", "alt", "title"]
const _hoisted_7 = { class: "text-xl font-semibold" }
const _hoisted_8 = {
  key: 0,
  class: ""
}
const _hoisted_9 = { class: "flex-none min-w-full text-clay-950" }
const _hoisted_10 = { class: "flex justify-between" }
const _hoisted_11 = { class: "mr-4" }
const _hoisted_12 = {
  key: 0,
  class: "text-clay-800"
}
const _hoisted_13 = { class: "mb-2 text-sm text-clay-800 line-clamp-2" }
const _hoisted_14 = { class: "mt-2 ml-4 shrink-0" }
const _hoisted_15 = { class: "relative inline-flex items-center" }


import Bookmarking from "@/main/components/Bookmarking.vue";
import {LearningModuleDtoLightWeight} from "@/dtos";


export default /*@__PURE__*/_defineComponent({
  __name: 'LearningModuleCard',
  props: {
    module: {},
},
  setup(__props) {

const props = __props

const module: LearningModuleDtoLightWeight = props.module;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(module).imageUrl)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: `/${_unref(module).id}/${_unref(module).slug}`,
          alt: _unref(module).topic,
          title: _unref(module).topic,
          class: "shrink-0 guide-img-container"
        }, [
          _createElementVNode("img", {
            src: _unref(module).imageUrl,
            alt: _unref(module).topic,
            title: _unref(module).topic,
            class: "object-cover w-20 h-20 p-4 md:w-48 md:h-full rounded-3xl sm:p-0"
          }, null, 8, _hoisted_3)
        ], 8, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("a", {
          href: `/${_unref(module).id}/${_unref(module).slug}`,
          alt: _unref(module).topic,
          title: _unref(module).topic,
          class: "hover:underline"
        }, [
          _createElementVNode("h3", _hoisted_7, _toDisplayString(_unref(module).topic), 1)
        ], 8, _hoisted_6),
        (_unref(module).subtitle2)
          ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_unref(module).subtitle2), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(module).excerpt), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("dl", _hoisted_11, [
          (_unref(module).subtitle1)
            ? (_openBlock(), _createElementBlock("dd", _hoisted_12, _toDisplayString(_unref(module).subtitle1), 1))
            : _createCommentVNode("", true),
          _createElementVNode("dd", _hoisted_13, _toDisplayString(_unref(module).learningModelCategories.join(", ")), 1)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createVNode(Bookmarking, {
                id: _unref(module).id
              }, null, 8, ["id"])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})